import { ChangeEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../auth/authStore';
import { useModalStore } from '../../../shared/store/uiStore';
import { generateDiagram } from '@diagram/service/diagram.function';

const DiagramAIForm = () => {
  const user = useAuthStore((state) => state.auth);
  const navigate = useNavigate();
  const [formData, setFormData] = useState('');
  const { closeModal, setLoading } = useModalStore((state) => state);
  const [error, setError] = useState<string | null>(null);

  if (!user) return null;

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setFormData(e.target.value);
  };

  const handleSubmit = async (e: ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    generateDiagram(formData)
      .then(async (diagramId) => {
        navigate(`v1/diagram/${diagramId}`);
        closeModal();
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to generate diagram. Please try again.');
        setLoading(false);
      });
  };

  return (
    <form
      className="flex flex-col gap-4 mx-auto justify-center items-center"
      id="diagram-form"
      onSubmit={handleSubmit}
    >
      {error && <p className="text-red-500">{error}</p>}
      <div className="flex gap-4">
        <textarea
          className="border border-gray-300 rounded-md p-2 w-96 h-40"
          placeholder="Enter your AI prompt here, leave blank to create a blank diagram."
          value={formData}
          onChange={handleChange}
        />
      </div>
    </form>
  );
};
export default DiagramAIForm;
